import { render, staticRenderFns } from "./NaikinimasAktasParametrai.vue?vue&type=template&id=dcad166e&scoped=true&"
import script from "./NaikinimasAktasParametrai.vue?vue&type=script&lang=js&"
export * from "./NaikinimasAktasParametrai.vue?vue&type=script&lang=js&"
import style0 from "./NaikinimasAktasParametrai.vue?vue&type=style&index=0&id=dcad166e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcad166e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
